var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 13,
    viewBox: "0 0 23 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.263523 5.86404C0.263792 5.86377 0.264017 5.86345 0.264332 5.86318L4.95885 1.19131C5.31054 0.841323 5.87938 0.842626 6.22946 1.19436C6.57949 1.54606 6.57814 2.1149 6.22645 2.46493L3.07455 5.60156H22.1016C22.5978 5.60156 23 6.00379 23 6.49999C23 6.9962 22.5978 7.39843 22.1016 7.39843H3.0746L6.22641 10.5351C6.5781 10.8851 6.57944 11.4539 6.22941 11.8056C5.87934 12.1574 5.31045 12.1586 4.9588 11.8087L0.264286 7.13681C0.264017 7.13654 0.263792 7.13622 0.263477 7.13595C-0.0883961 6.78475 -0.0872726 6.21407 0.263523 5.86404Z",
    fill: "#221A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.37ca5152d3430f78dd0c718d62945c26.svg";
export { ForwardRef as ReactComponent };